<template>
  <div>
    <el-row :gutter="10" class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="14">
        <el-input v-model="filtro.nome" placeholder="Pesquisar grupo" @keyup.native.enter="load"></el-input>
      </el-col>
      <el-col :xs="24" :sm="10" class="u-text-right">
        <el-button class="u-mr-10" @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
        <router-link to="/admin/merenda/grupo-consumo/cadastro" class="btn-new-register" v-if="podeEscrever">
          <el-button type="primary">NOVO GRUPO</el-button>
        </router-link>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width:70px;">cod</th>
            <th>Grupo</th>
            <th class="hidden-mobile" style="width:110px;">Turno</th>
            <th class="u-text-center" style="width:110px;">Alunos</th>
            <th class="hidden-mobile u-text-center" style="width:80px;">Ativo</th>
            <th style="width:200px;" class="u-text-center">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in items" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td>{{ item.nome }}<div class="u-fs-12" v-if="item.descricao">{{ item.descricao }}</div></td>
            <td class="hidden-mobile">{{ item.turno || '—' }}</td>
            <td class="u-text-center">{{ item.qtd_ativos }}</td>
            <td class="hidden-mobile u-text-center">{{ item.situacao ? 'SIM' : 'NÃO' }}</td>
            <td class="u-text-center acao">
              <el-button @click="verHistorico(item)" title="Histórico de vínculos" type="warning" icon="el-icon-time" size="mini" plain></el-button>
              <router-link :to="'/admin/merenda/grupo-consumo/edit/' + item.id" class="link-icon u-ml-10" style="color: rgba(0,0,0,.87)!important;" v-if="podeEscrever">
                <el-button type="info" title="Editar / vincular" icon="el-icon-edit" size="mini" plain></el-button>
              </router-link>
              <el-button v-if="podeEscrever" @click="deleteItem(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain class="u-ml-10"></el-button>
            </td>
          </tr>
          <tr v-if="items.length === 0"><td colspan="6" class="u-text-center">Nenhum grupo de consumo cadastrado.</td></tr>
        </tbody>
      </table>
    </div>

    <el-dialog :title="'Histórico de vínculos — ' + (grupoSel ? grupoSel.nome : '')" :visible.sync="dialogHist" width="720px">
      <el-alert class="u-mb-10" type="info" :closable="false" show-icon
        title="Vínculos realizados e desfeitos. Desfazer não apaga o registro — o histórico permanece."></el-alert>
      <table class="table table-striped" v-if="historico.length">
        <thead>
          <tr><th>Aluno</th><th style="width:120px;">Vínculo</th><th style="width:120px;">Desvínculo</th><th>Motivo</th><th style="width:100px;">Situação</th></tr>
        </thead>
        <tbody>
          <tr v-for="h in historico" :key="h.vinculo_id">
            <td>{{ h.aluno }}</td>
            <td>{{ h.data_vinculo }}</td>
            <td>{{ h.data_desvinculo || '—' }}</td>
            <td class="u-fs-12">{{ h.motivo_desvinculo || '—' }}</td>
            <td><el-tag size="mini" :type="h.situacao === 'ativo' ? 'success' : 'info'">{{ h.situacao }}</el-tag></td>
          </tr>
        </tbody>
      </table>
      <div v-else class="u-fs-12">Nenhum vínculo registrado para este grupo.</div>
      <span slot="footer"><el-button @click="dialogHist = false">FECHAR</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    statusList: false, filtro: { nome: '' }, items: [],
    dialogHist: false, historico: [], grupoSel: null
  }),
  computed: {
    podeEscrever () { return [0, 1, 4, 5, 6, 7, 12].indexOf(Number(this.$store.state.user.tipo)) !== -1 }
  },
  mounted () { this.load() },
  methods: {
    load () {
      this.statusList = false
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/grupo-consumo/getAllPaginate`, this.filtro, this.$store.getters.getHeaderAuth)
        .then(r => { this.items = r.data.data || []; this.statusList = true })
        .catch(e => this.$store.commit('throwException', e))
    },
    verHistorico (grupo) {
      this.grupoSel = grupo
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/grupo-consumo/historico`, { grupo_consumo_id: grupo.id }, this.$store.getters.getHeaderAuth)
        .then(r => { this.historico = (r.data && r.data.erro) ? [] : (r.data.linhas || []); this.dialogHist = true })
        .catch(e => this.$store.commit('throwException', e))
    },
    deleteItem (id) {
      this.$msgbox.confirm('Excluir este grupo de consumo?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/grupo-consumo/delete/` + id, this.$store.getters.getHeaderAuth)
            .then(r => {
              if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.load()
            }).catch(e => this.$store.commit('throwException', e))
        }).catch(() => {})
    }
  }
}
</script>
